import { BrowserRouter as Router, Route } from 'react-router-dom'
import Footer from './components/Footer'
import Navigation from './components/Navigation'
import BackToTop from './components/BackToTop'
import HomeScreen from './screens/HomeScreen'
import Encume from './screens/Encume'
import QuienesSomos from './screens/QuienesSomos'
import PrivacyPolicy from './screens/PrivacyPolicy'
import Friends from './screens/Friends'
import Libro from './screens/Libro'
import Publications from './screens/Publications'
import FullPhotoArchive from './screens/fullPhotoArchive/FullPhotoArchive'
import Articles from './screens/Articles'
import ArticleDetail from './screens/article/ArticleDetail'
import Memories from './screens/Memories'
import RedPage from './screens/RedPage'
import EducationPage from './screens/EducationPage'
import ResearchPage from './screens/ResearchPage'
import ActivismPage from './screens/ActivismPage'
import WhatWeDoPage from './screens/WhatWeDoPage'
import UbTrainingPage from './screens/UbTrainingPage'
import MenstrualCulturePage from './screens/MenstrualCulturePage'
import BookDescriptionEN from './screens/BookDescriptionEN'

import './App.scss'
import './App.css'
import ScrollToTop from './utilities/ScrollToTop'

const App = () => {
  return (
    <Router>
        <ScrollToTop />
        <Navigation />
        <main>
            <Route
              path='/'
              exact
              render={() => <HomeScreen showAssociationCampaignPopup />}
            />
            <Route
              path='/asociacion'
              exact
              render={({ location }) => (
                <HomeScreen key={location.key || location.pathname} showAssociationCampaignPopup />
              )}
            />
            <Route path='/cultura-menstrual' component={MenstrualCulturePage} />
            <Route path='/encume' component={Encume} />
            <Route path='/conocenos' component={QuienesSomos} />
            <Route path='/politicaprivacidad' component={PrivacyPolicy} />
            <Route path='/hazte-amiga' component={Friends} />
            <Route path='/educacion' component={EducationPage} />
            <Route path='/investigacion' component={ResearchPage} />
            <Route path='/activismo' component={ActivismPage} />
            <Route path='/que-hacemos' component={WhatWeDoPage} />
            <Route path='/formacion-ub' component={UbTrainingPage} />
            <Route path='/libro' component={Libro} exact />
            <Route path='/libro-en' component={BookDescriptionEN} />
            <Route path='/publicaciones' component={Publications} />
            <Route path='/memorias' component={Memories} />
            <Route path='/red' component={RedPage} />
            <Route path='/archivo' component={FullPhotoArchive} />
            <Route path='/articulos' component={Articles} exact />
            <Route path='/articulos/:slug' component={ArticleDetail} />
        </main>
        <Footer />
        <BackToTop />
    </Router>
  )
}

export default App
